import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";

/**
 * QuizContentComponent.js
 * 
 * Created on Jan 8, 2015, 4:06:11 PM
 *
 * @author Harm Boschloo for Ranj
 **/
export default class QuizContentComponent extends Content {
    constructor(languagePack, contentID, npcID, quizDialogID, playerInitiated, label) {
        super(QuizContentComponent.NAME, QuizContentComponent.TYPE, label, languagePack, contentID);
        this._npcID = npcID;
        this._quizDialogID = quizDialogID;
        this._playerInitiated = playerInitiated;
    }

    remove() {
        this._npcID = null;
        this._quizDialogID = null;
        super.remove();
    }

    getNpcID() {
        return this._npcID;
    }

    setNpcID(value) {
        this._npcID = value;
    }

    getQuizDialogID() {
        return this._quizDialogID;
    }

    setQuizDialogID(value) {
        this._quizDialogID = value;
    }

    getPlayerInitiated() {
        return this._playerInitiated;
    }

    setPlayerInitiated(value) {
        this._playerInitiated = value;
    }

    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_QUIZ, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setNpcID(this.getNpcID());
        clone.setQuizDialogID(this.getQuizDialogID());
        clone.setPlayerInitiated(this.getPlayerInitiated());
        return clone;
    }

    convertToObject() {
        return this.getObject(["npcID", "quizDialogID", "playerInitiated"]);
    }

    getDescriptionLabel() {
        let label;

        label = this.dialogID.toString();
        if (isNull(label) || label === "") {
            label = "Quiz: <NO QUIZ>";
        }
        else {
            label = `Quiz: ${label}`;
        }
        return label;
    }
}

QuizContentComponent.NAME = "Quiz";
QuizContentComponent.TYPE = "engQuizContentComponent";